module.exports = __webpack_public_path__ + "static/media/b5.5b33d5f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengqingsheng/b5.mp3
// module id = 619e
// module chunks = 0